import NumberFlow, { type Format } from "@number-flow/react";
import { useEffect, useState } from "react";

import {
  formatCount,
  getCurrentBcp47Locale,
} from "@/react/helpers/localeHelpers";

interface AnimatedCountProps {
  compact?: boolean;
  count: number;
  initialCount?: number;
}

const TIMING = { duration: 500, easing: "ease-out" };
const COMPACT_FORMAT: Format = {
  notation: "compact",
  maximumFractionDigits: 1,
};
const STANDARD_FORMAT: Format = { maximumFractionDigits: 0 };

export const AnimatedCount = ({
  count,
  initialCount = count,
  compact = true,
}: AnimatedCountProps) => {
  const [isInitialTransition, setIsInitialTransition] = useState(
    () => initialCount === 0 && count > 0,
  );

  useEffect(() => {
    if (isInitialTransition) setIsInitialTransition(false);
  }, [isInitialTransition]);

  return (
    <NumberFlow
      className="inline-flex items-center whitespace-nowrap tabular-nums [&::part(digit)]:w-[1ch] [&::part(digit)]:text-center"
      value={isInitialTransition ? 0 : count}
      locales={getCurrentBcp47Locale()}
      format={compact ? COMPACT_FORMAT : STANDARD_FORMAT}
      transformTiming={TIMING}
      opacityTiming={TIMING}
      aria-label={formatCount(count)}
      aria-live="polite"
      aria-atomic="true"
    />
  );
};
